import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

export default function Submit() {
  useSeo({
    title: "Sell Your Gift Card in 2 Minutes — Instant Payout | GC Nexon",
    description: "Submit your gift card and get paid the same day via PayPal, Zelle, Cash App, Chime, or Bitcoin. Competitive rates, transparent offers, no surprise fees.",
    path: "/submit",
  });
  return <WebflowPage htmlPath="/site/submit.html" title="Sell a gift card — GC Nexon" />;
}
